import {Checkbox, NumberInput, TextInput} from "@mantine/core";
import {DateInput} from "../../date/DateInput/DateInput";
import {EntitySelect} from "../../select/entity/EntitySelect/EntitySelect";
import {customFieldDefDataType, CustomFieldProfileItemEntity} from "@ots-frontend/ots-data";
import {UseFormReturnType} from "@mantine/form";

export interface CustomField {
  item: CustomFieldProfileItemEntity;
  value: any;
}

export function renderCustomFieldValueInput<V>(
  item: CustomFieldProfileItemEntity,
  form: UseFormReturnType<V, (values: V) => V>,
  options?: { regionId?: string }
) {
  const path = `custom.${item.id}` as const;
  const label = typeof item.label !== "undefined" ? item.label : item.defLabel;
  const required = typeof item.required !== "undefined" ? item.required : item.defRequired;

  switch (item.defDataType) {
    case customFieldDefDataType.boolean:
      return (
        <Checkbox
          size="xs"
          label={label}
          {...form.getInputProps(path, {type: "checkbox"})}
          mb="sm"
        />
      );

    case customFieldDefDataType.number:
      return (
        <NumberInput
          size="xs"
          label={label}
          withAsterisk={required}
          required={required}
          {...form.getInputProps(path)}
        />
      );

    case customFieldDefDataType.temporal:
      return (
        <DateInput
          label={label}
          withAsterisk={required}
          required={required}
          size="xs"
          valueFormat="MM/DD/YYYY HH:mm"
          clearable
          {...form.getInputProps(path)}
        />
      );

    case customFieldDefDataType.ref:
      return (
        <EntitySelect
          entityType={item.defRefObjectType}
          label={label}
          regionId={options?.regionId}
          clearable={!required}
          withAsterisk={required}
          required={required}
          searchable
          {...form.getInputProps(path)}/>
      )

    case customFieldDefDataType.string:
      return (
        <TextInput
          label={label}
          withAsterisk={required}
          required={required}
          size="xs"
          {...form.getInputProps(path)}
        />
      )
  }
}
